var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoped(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#000000;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st1{fill:none;stroke:#000000;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 4.2,
    y1: 8.5,
    x2: 9.5,
    y2: 8.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.9,4.4C14.9,4.4,14.9,4.4,14.9,4.4c0.7,1,1.6,2.3,2.2,4c0.8,2,1,3.8,1,5c0.4,0.1,1.1,0.3,1.8,0.7 c0.6,0.4,1,0.8,1.3,1.1l-1.1,1c-1.1,0-2.4-0.2-3.3,0.4c-0.3,0.2-0.6,0.4-0.8,0.6H7.8c-0.7-0.2-1.7-0.6-2.7-1.3 c-1-0.6-1.8-1.3-2.3-1.9c0-0.4,0.1-0.8,0.3-1.3C3.5,11.9,4,11.3,4.3,11h5.2v2c0,0.5,0.4,1,1,1h3.2c0.8,0,1.5-0.5,1.7-1.3 c0.1-0.7,0.3-1.5,0.3-2.4C15.9,7.7,15.3,5.7,14.9,4.4C14.9,4.4,14.9,4.4,14.9,4.4L14.9,4.4H12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4,4.9c0-0.1,0.1-0.2,0.2-0.3c0.3-0.2,0.6-0.3,0.8-0.4h1.5c0.1,0,0.2,0.1,0.2,0.2V6c-0.1,0.1-0.2,0.2-0.3,0.2H16 L15.4,4.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M7.5,17.2c0.1,0.2,0.1,0.4,0.1,0.7c0,1.1-0.9,1.9-1.9,1.9S3.8,19,3.8,17.9c0-0.9,0.6-1.6,1.4-1.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M17,16.5L17,16.5c-0.3,0.3-0.4,0.7-0.4,1.3c0,1.2,0.8,2,1.9,2s1.9-0.8,1.9-2c0-0.7-0.3-1.3-0.8-1.7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoped);
export default __webpack_public_path__ + "static/media/moped.7f9aed94dd2877a7203d271f9548774b.svg";
export { ForwardRef as ReactComponent };